(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  
  
  
  
  
  const dropdownMenuLink = document.querySelector('#dropdownMenuLink');
console.log(dropdownMenuLink.id, document.querySelector(`[aria-labelledby="${dropdownMenuLink.id}"]`))
  if(dropdownMenuLink) {
    let activeEl = document.querySelector(`[aria-labelledby="${dropdownMenuLink.id}"]`);

    if(activeEl) {
      dropdownMenuLink.addEventListener('click', (ev) => {
        ev.preventDefault();
        activeEl.classList.toggle('show');
      })
    }
  }
  






  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-footer"]) return;
  try {
    
    $('.inner_lash_like').slick({
      dots: false,
    infinite: false,
      arrows: false,
    slidesToShow: 4,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          dots: true,
          infinite: false,
          arrows: false,
          slidesToShow: 1
        }
      }
    ]
  });

  } catch(e) { console.error(e); }
})();
})();
